import React from "react"
import classNames from "classnames"
import PropTypes from "prop-types"

import styles from "./TrendingCard.module.scss"
import RemoteArticleImage from "../RemoteArticleImage/RemoteArticleImage"

const TrendingCard = ({ classes, title, text, imgUrl, onClick }) => {
  return (
    <div className={classNames(styles.card, classes)} onClick={onClick}>
      <h6 className={styles.title}>{title}</h6>

      {!!text && <p className={styles.description}>{text}</p>}

      {!!imgUrl && (
        <RemoteArticleImage
          src={imgUrl}
          className={styles.img}
          alt={title || ""}
        />
      )}
    </div>
  )
}

TrendingCard.propTypes = {
  classes: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  imgUrl: PropTypes.string,
  onClick: PropTypes.func,
}

export default TrendingCard
